<script setup>
import { computed, useSlots } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  labelFor: {
    type: String,
    default: null,
  },
  help: {
    type: String,
    default: null,
  },
  required: Boolean,
  isoneintwo: Boolean,
  hidden: Boolean,
  addclassad: String
});

const slots = useSlots();

const wrapperClass = computed(() => {
  const base = [];
  const slotsLength = slots.default().length;

  if (props.addclassad) {// LRR <-- Agregar más clases
    base.push(props.addclassad)
  } else {
    if (slotsLength > 1) {
      base.push("grid grid-cols-1 gap-3");
    }

    if (slotsLength === 2) {
      base.push("md:grid-cols-2");
    } else if (slotsLength === 3) {
      base.push("md:grid-cols-3");
    } else if (slotsLength === 4) {
      base.push("md:grid-cols-4");
    }

    if (props.isoneintwo) {// LRR
      base.push("grid grid-cols-4 gap-3")
    }

  }

  return base;
});
</script>

<template>
  <div class="mb-6 last:mb-0" :style="hidden ? 'display:none' : ''">
    <label v-if="label" :for="labelFor" class="block font-bold mb-2">{{
      label
    }}<span class="text-red-600" v-if="required" > * </span></label>
    <div :class="wrapperClass">
      <slot />
    </div>
    <div v-if="help" class="text-xs text-gray-500 dark:text-slate-400 mt-1">
      {{ help }}
    </div>
  </div>
</template>
